import { t } from "@lingui/macro";
import { useCreateCredit } from "@/client/services/credit/create";
import { useRequestWithdrawal } from "@/client/services/withdrawals/create-request";
import { useDialog } from "@/client/stores/dialog";
import { CreateCreditDto } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Form,
  FormField,
  FormLabel,
  Input,
  FormItem,
  FormControl,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";

export const CreateCreditDialog = () => {
  type FormValue = CreateCreditDto;
  const formRef = useRef<HTMLFormElement>(null);
  const { addCredit } = useCreateCredit();
  const { isOpen, mode, close, payload } = useDialog<{ id: string }>("create-credit");
  const form = useForm<FormValue>({
    defaultValues: {
      quantity: 0,
    },
  });
  const OnSubmit = (data: FormValue) => {
    const userId = payload?.item?.id;

    if (!userId) {
      return;
    }

    try {
      data.quantity = Number(data.quantity);
      data.remain = data.quantity;
      // `payload` peut être indéfini (dialogue ouvert sans item) :
      // sémantique d'origine conservée, le backend valide ensuite.
      data.userId = payload?.item?.id;
      addCredit(data);
    } catch {
      form.reset();
    }
  };
  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t`Ajouter des crédits`}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <FormField
              name="quantity"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{`Quantité`}</FormLabel>
                  <FormControl>
                    <Input type="number" {...field} />
                  </FormControl>
                </FormItem>
              )}
            />
            <div className="flex flex-row justify-center">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
